<template>
  <ion-page>
    <main-header :back-href="defaultBackHref"></main-header>
    <ion-content padding>
      <ion-grid>
        <ion-row>
          <ion-col size-md="6" offset-md="3">
            <div class="ion-text-center">
              <h1 class="ion-no-margin">Forgot Your Password?</h1>
              <p>
                Enter your email and we'll send you a link to reset your
                password.
              </p>
            </div>
            <form @submit.prevent="handleSubmit()">
              <ion-list lines="full">
                <input-box
                  :validator="$v.email"
                  :error-messages="{
                    required: 'Please enter your email.',
                    email: 'That email address doesn\'t appear to be valid.'
                  }"
                  :required="true"
                  type="email"
                  v-model="email"
                  @input="errorUserNotFound = false"
                >
                  Your Email
                </input-box>
                <ion-item v-if="errorUserNotFound" color="danger">
                  That email address is not a valid user.
                </ion-item>
              </ion-list>
              <div class="ion-padding">
                <submit-button :submitting="submitting">
                  Send Reset Link
                </submit-button>
              </div>
            </form>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import ErrorAlert from "@/ErrorAlert";
import submittable from "@/mixins/submittable";
import PlatformService from "@/services/Platform";

export default {
  title: "Forgot Password",

  mixins: [submittable],

  data: function() {
    return {
      email: "",
      errorUserNotFound: false
    };
  },

  methods: {
    handleSubmit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const actionCodeSettings = {
          handleCodeInApp: !PlatformService.isWeb(),
          url: "https://" + process.env.VUE_APP_FIREBASE_AUTH_DOMAIN
        };
        if (PlatformService.isMobile()) {
          if (PlatformService.isAndroid()) {
            actionCodeSettings.android = {
              packageName: process.env.VUE_APP_ANDROID_PACKAGE_NAME
            };
          } else {
            actionCodeSettings.iOS = {
              bundleId: process.env.VUE_APP_ANDROID_PACKAGE_NAME
            };
          }
        }

        this.$auth()
          .sendPasswordResetEmail(this.email, actionCodeSettings)
          .then(() => {
            this.$v.email.$reset();
            this.email = "";
            this.successToast(
              "An email has been sent with your password reset link."
            );
          })
          .catch(error => {
            if (error.code == "auth/user-not-found") {
              this.errorUserNotFound = true;
            } else {
              ErrorAlert(error.message);
            }
          });
      }
    }
  },

  computed: {
    defaultBackHref() {
      return this.$router.resolve({
        name: "Sign In With Email"
      }).href;
    }
  },

  validations: {
    email: {
      required,
      email
    }
  }
};
</script>
